module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.sections.length > 0) ? _c('section', {
    staticClass: "sections"
  }, [_vm._l((_vm.sections), function(section, index) {
    return [_c('paragraph', {
      key: _vm.nid + '_' + index,
      attrs: {
        "section": section,
        "index": index,
        "sizes": _vm.sizes
      }
    })]
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb10cfd2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Paragraphs.vue
// module id = 52
// module chunks = 0